import React from "react"

export const H4 = ({className="text-large_oak", children}: {className?:string, children: React.ReactNode}) => {
    return (
        <h2 className={`text-base font-bold ${className ?? ''}`}>{children}</h2>
    )
}